<template>
  <div class="deck-header">
    <Breadcrumb :breadcrumb="flashCardBreadcrumb" class="flash-card-deck-breadcrumb" />
    <div class="holder-info">
      <h1 class="title h2">
        {{ deck.title }}
      </h1>
      <div class="info">
        <span class="author">Author: <span class="bold">{{ deck.author }}</span></span>
        <span class="dot" />
        <span class="cards">Cards: <span class="bold">{{ deck.cardCount }}</span></span>
      </div>
    </div>
    <div v-if="!$route.path.includes('/results/')" class="types-tabs row">
      <div class="col-12">
        <div class="tabs">
          <li v-for="tab in tabs" :key="tab.name" :class="{ active: $route.name.includes(tab.href) || $route.query[tab.href] }">
            <nuxt-link v-if="tab.href === 'study' || tab.href === 'review'" :to="`/flashcards/${deck.slug}/${tab.href}/`">
              {{ tab.name }}
            </nuxt-link>
            <button
              v-else class="btn-primary" :class="{ active: $route.path.includes(tab.href) }"
              @click="routeTest"
            >
              {{ tab.name }}
            </button>
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Breadcrumb from '@itbpbg/lms-components/src/components/Breadcrumb.vue';

export default {
  components: {
    Breadcrumb,
  },
  props: {
    deck: { type: Object, required: true },
  },
  data() {
    return {
      warning: false,
      tabs: [
        { href: 'review', name: 'Review' },
        { href: 'study', name: 'Study' },
        { href: 'test', name: 'Test' },
      ],
    };
  },
  computed: {
    flashCardBreadcrumb() {
      return [
        {
          slug: '/flashcards/',
          name: 'All Decks',
        },
        {
          slug: '',
          name: `${this.deck.title}`,
        },
      ];
    },
  },
  mounted() {
    this.$root.$on('start-test', () => {
      this.warning = true;
    });
  },
  methods: {
    async routeTest() {
      if (!this.$store.state.auth.user) {
        this.$store.dispatch('modals/open', {
          name: 'login-or-signup',
        });
      } else {
        const reviewMode = this.$route.path.includes('review');
        const confirm = await this.$store.dispatch('modals/open', {
          name: 'confirm',
          title: 'Are you sure you want to start the test now?',
          customClass: 'flashcards-modal',
          message: reviewMode ? 'You haven’t reviewed all cards. Go over the whole deck for a chance of a higher score.' : 'You haven’t rated all cards. Go back and complete the deck for a chance of a higher score.',
          confirm: 'Start Test',
          confirmBtnClass: 'btn-danger-light',
          reverseButtonsOrder: true,
          cancel: 'Go Back',
          cancelBtnClass: 'btn-primary',
        });
        if (confirm) {
          this.$router.push(`/flashcards/${this.deck.slug}/test/`);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.deck-header {
  ::v-deep {
    .flash-card-deck-breadcrumb {
      margin-top: var(--spacing-160);
    }
  }

  .holder-info {
    margin-top: var(--spacing-12);

    .title {
      margin-bottom: var(--spacing-12);
    }

    .info {
      color: var(--main-dark-light-3);
      font-size: 18px;
      line-height: 140%;

      .bold {
        color: var(--main-dark-light-2);
        font-weight: 500;
      }

      .dot {
        &:before {
          content: '';
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: var(--main-dark-light-3);
          display: inline-block;
          vertical-align: middle;
          margin: 0 var(--spacing-8);
        }
      }
    }
  }

  .types-tabs {
    margin: var(--spacing-20) 0;

    .tabs {
      display: flex;

      li {
        list-style: none;
        width: 95px;
        height: 40px;
        margin-right: var(--spacing-12);
        background: #E6E9E8;
        border-radius: 8px;

        button {
          width: 100%;
          height: 100%;
          padding: 0;
          border: unset;
          background: #E6E9E8;
          font-size: 18px;
          font-weight: 500;
          line-height: 110%;
          color: var(--main-dark-light-3);
        }

        &:last-of-type {
          margin-right: 0;
        }

        a {
          font-size: 18px;
          font-weight: 500;
          line-height: 110%;
          width: 100%;
          height: 100%;
          color: var(--main-dark-light-3);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &.active {
          background: var(--main-light-shade-4);

          a {
            color: var(--main-dark);
          }

          button {
            background: var(--main-light-shade-4);
            color: var(--main-dark);
          }
        }
      }
    }
  }

  @include bp($bp-mobile) {
    ::v-deep {
      .flash-card-deck-breadcrumb {
        margin-top: 128px;
      }
    }

    .holder-info {
      .title {
        font-size: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .info {
        font-size: 16px;

        .dot:before {
          width: 6px;
          height: 6px;
        }
      }
    }
  }
}
</style>
